(function ($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfJoinFormTab', [function () {
        return {
            'restrict': 'E',
            'replace': true,
            'templateUrl': function (elem, attr) {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/tabs/' + attr.panel + '.html');
            }
        };
    }]);
})(jQuery, angular, window);
